import { isTouch } from 'lib/support'

/** @type {object} */
const IMAGE_PROMISES = {}

/**
 * Loads an image at the given src
 *
 * @param {string} src - the src url
 * @returns {Promise} resolves on completion
 */
const loadImage = src =>
  new Promise((resolve, reject) => {
    const i = new Image()

    i.crossOrigin = true

    i.onload = () => {
      i.decode
        ? i
          .decode()
          .then(() => resolve(i))
          .catch(reject)
        : resolve(i)
    }

    i.onerror = reject
    i.src = src
  })

/**
 * Loads an image, while checking for the existence of
 * cached data
 *
 * @param {string} src - the src url
 * @returns {Promise} resolves on completion
 */
const load = src => {
  if (IMAGE_PROMISES[src]) {
    return IMAGE_PROMISES[src]
  }

  const promise = loadImage(src)

  if (!isTouch) {
    // Cache result
    IMAGE_PROMISES[src] = promise
  }

  return promise
}

export default {
  load
}
